import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getReminders(params) {
        return Axios.get(`${baseURL}schedule/reminder`, { params }).then(
            response => response.data.response
        );
    },
    getReminderType(clientId, reminderType) {
        let params = {
            default_reminder_type: reminderType,
            cid: clientId
        };
        return Axios.get(
            `${baseURLci}patient/reminder/filter_client_reminder_type`,
            { params }
        ).then(response => response.data);
    },
    getItems(searchKey) {
        let params = {
            search_key: searchKey,
            module: "reminder"
        };
        return Axios.get(`${baseURLci}ajax/item/filter_items`, { params }).then(
            response => response.data
        );
    },
    getItemActionOption(itemId, actionsKey) {
        let params = {
            item_id: itemId,
            actions_key: actionsKey
        };
        return Axios.get(`${baseURLci}ajax/item/get_reminder_action_options`, {
            params
        }).then(response => response.data);
    },
    saveReminder(formData) {
        return Axios.post(`${baseURLci}common/reminder/save`, formData).then(
            response => response.data
        );
    },
    deleteReminder(params) {
        return Axios.delete(`${baseURL}schedule/reminder`, { params }).then(
            response => response.data
        );
    },
    completeReminder(params) {
        return Axios.get(`${baseURLci}client/reminder/complete`, {
            params
        }).then(response => response.data);
        // to be used once ready
        // return Axios.post(`${baseURL}schedule/reminder/complete`, { params }).then(response => response.data );
    },
    sendReminder(params) {
        return Axios.get(`${baseURLci}schedule/reminder/send`, { params }).then(
            response => response.data
        );
    },
    sendBulkReminder(params) {
        return Axios.post(`${baseURL}schedule/reminder/bulkResend`, { params }).then(
            response => response.data
        );
    },
    saveReminderAsTask(formData) {
        return Axios.post(
            `${baseURLci}common/reminder/save_task`,
            formData
        ).then(response => response.data);
    },
    getFutureReminders(params) {
        return Axios.get(`${baseURL}schedule/future-reminders`, {
            params
        }).then(response => response.data.response);
    },
    filterReminderTypeByPatient(patientId) {
        return Axios.get(
            `${baseURL}patient/filter-reminder-type/${patientId}`
        ).then(response => response.data.response);
    }
};
